var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5858 23.4143C21.3668 24.1953 22.6331 24.1953 23.4142 23.4143C24.1952 22.6332 24.1952 21.3669 23.4142 20.5859L14.8284 12L23.4142 3.41427C24.1952 2.63322 24.1952 1.36689 23.4142 0.585843C22.6331 -0.195205 21.3668 -0.195204 20.5858 0.585845L12 9.1716L3.41426 0.585791C2.63322 -0.195261 1.36689 -0.195264 0.585836 0.585782C-0.195215 1.36683 -0.195219 2.63316 0.585828 3.41421L9.1716 12L0.585785 20.5859C-0.195262 21.3669 -0.195262 22.6332 0.585787 23.4143C1.36684 24.1953 2.63317 24.1953 3.41421 23.4143L12 14.8285L20.5858 23.4143Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWhite);
export default __webpack_public_path__ + "static/media/icon-close-white.ad2215cae1aaa737c22aff73a5fd5d9b.svg";
export { ForwardRef as ReactComponent };